import {ArgumentValidator} from '@/shared/helpers/argument-validator';

export class UriHelper {

    public static extractUriSegments(uri: string, segmentCount: number): string {

        ArgumentValidator.notNullOrEmpty(uri, `uri`);
        ArgumentValidator.notLessThanOrEqualToZero(segmentCount, `segmentCount`);

        const uriWithoutProtocol = uri.replace(/^ev:\/\//, '');
        const typeMatch = uriWithoutProtocol.match(/^([^/]+)\//);
        const typePart = typeMatch ? typeMatch[1] : '';

        const uriWithoutType = uriWithoutProtocol.replace(/^[^/]+\//, '');

        const cleanedUri = uriWithoutType.replace(/^\/*|\/*$/g, '');

        const segments = cleanedUri.split('/');

        const limitedSegments = segments.slice(0, segmentCount);

        const newUri = limitedSegments.join('/');

        return 'ev://' + (typePart ? typePart + '/' : '') + (newUri ? newUri + '/' : '');
    }
}
